module.exports = __webpack_public_path__ + "img/cyclon.39ace017.png";